import httpService from "@/utils/httpService";

const baseUrl = "api/tags/typesCounts";
export default {
    /**
     * Get tags types counts for an asset
     * @param {Object} params - Request parameters
     * @param {string} params.assetId - Asset ID
     * @param {string[]} [params.types] - Tag types to fetch counts for
     * @param {AbortSignal} [signal] - Optional AbortSignal for cancellation
     */
    get(params, signal = null) {
        const { assetId, types = [] } = params;
        const typesParam = Array.isArray(types) ? types.join('&types=') : '';

        return httpService.get({
            url: `${baseUrl}/${assetId}?types=${typesParam}`,
            signal,
        });
    },
}